module.exports = __webpack_public_path__ + "img/SketchPng29efa7a04e20dfa8f389069893fb605dca349730782bdaffdb0436bc70e74255.8c6e1a4f.png";